export const AUTH0_SCOPE =
  'read:current_user update:current_user_metadata read:users openid profile email offline_access app_metadata';

export const embeddedAuthConfig = {
  domain: import.meta.env.VITE_AUTH0_DOMAIN,
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
  audience: import.meta.env.VITE_AUTH0_AUDIENCE,
  scope: AUTH0_SCOPE,
  entraConnection: import.meta.env.VITE_AUTH0_ENTRA_CONNECTION,
  samlConnection: import.meta.env.VITE_AUTH0_SAML_CONNECTION,
};

export const BASE_API_URL =
  import.meta.env?.VITE_BUILD === 'development'
    ? import.meta.env?.VITE_API_PROXY_URL || 'http://localhost:1337/api'
    : import.meta.env?.VITE_API_URL;

export const DEV_ENVIRONMENTS = ['development'];

export const IS_PROD = import.meta.env?.VITE_BUILD === 'production';

export const APP_NAME = IS_PROD ? 'Dynamica' : 'Dynamica Staging';
